import React, {PureComponent, CSSProperties} from 'react'
import cxs from 'cxs'
import Theme from 'Theme'
import {t} from 'helpers/i18n'
import {CheckBox} from 'elements'

interface Props {
  name: string
  column?: string
  type: string
  value: boolean
  required?: boolean
  onChange(name: string, value: boolean, column?: string): void
}

class FieldCheckbox extends PureComponent<Props, object> {
  handleChange = (checked: boolean) => {
    this.props.onChange(this.props.name, checked, this.props.column)
  }

  render() {
    const {name, value, required} = this.props
    return (
      <CheckBox
        label={t(name) + (required ? '*' : '')}
        checked={value}
        className={className}
        onChange={this.handleChange}
      />
    )
  }
}

export default FieldCheckbox

const className = cxs({} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/FieldCheckbox.tsx